function initFeaturedSlider(slider) {
  if (!slider) return;
  if (slider.classList.contains('splide--featured-initialized')) return;

  const splide = new Splide(slider, {
    type: 'slide',
    perPage: 4,
    perMove: 1,
    gap: '30px',
    pagination: false,
    arrows: true,
    drag: true,
    breakpoints: {
      1024: { perPage: 3, gap: '20px' },
      768: { perPage: 2 },
      575: {
        perPage: 1,
        perMove: 1,
        padding: { right: '0px', left: '0px' }
      },
    },
  });
  const bar = slider.querySelector('.my-carousel-progress-bar');

  if (bar) {
    splide.on('mounted move', () => {
      const end = splide.Components.Controller.getEnd() + 1;
      const rate = Math.min((splide.index + 1) / end, 1);
      bar.style.width = `${rate * 100}%`;
    });
  }
  splide.mount();

  slider.classList.add('splide--featured-initialized');
}

function autoInitFeaturedSliders(scope = document) {
  scope.querySelectorAll('.fps-splide').forEach((slider) => {
    initFeaturedSlider(slider);
  });
}

document.addEventListener('DOMContentLoaded', () => autoInitFeaturedSliders());
document.addEventListener('shopify:section:load', (event) => autoInitFeaturedSliders(event.target));
document.addEventListener('shopify:section:select', (event) => autoInitFeaturedSliders(event.target));


function initStorySlider(slider) {
  if (!slider) return;
  if (slider.classList.contains('splide--featured-initialized')) return;

  const splide = new Splide(slider, {
    type: 'slide',
    perPage: 3,
    gap: '30px',
    pagination: false,
    arrows: true,
    drag: true,
    breakpoints: {
      1024: { perPage: 3, gap: '20px' },
      768: { perPage: 2 },
      575: { perPage: 1 }
    },
  });

  const bar = slider.querySelector('.my-carousel-progress-bar');

  if (bar) {
    splide.on('mounted move', () => {
      const end = splide.Components.Controller.getEnd() + 1;
      const rate = Math.min((splide.index + 1) / end, 1);
      bar.style.width = `${rate * 100}%`;
    });
  }

  splide.mount();
  slider.classList.add('splide--featured-initialized');
}


function autoInitStory(scope = document) {
  scope.querySelectorAll('.story-splide').forEach(initStorySlider);
  initStoryVideos(scope);
}

document.addEventListener('DOMContentLoaded', () => autoInitStory());

document.addEventListener('shopify:section:load', (e) => autoInitStory(e.target));
document.addEventListener('shopify:section:select', (e) => autoInitStory(e.target));


function initRelatedProductsSplide(scope = document) {
  scope.querySelectorAll('product-recommendations').forEach((section) => {
    const splideEl = section.querySelector('.products-available');

    if (!splideEl) return;
    if (splideEl.classList.contains('splide--related-initialized')) return;

    const splide = new Splide(splideEl, {
      type: 'slide',
      perPage: 4,
      gap: '20px',
      arrows: true,
      pagination: false,
      drag: true,
      breakpoints: {
        1200: {
          perPage: 3
        },
        990: {
          perPage: 2
        },
        750: {
          perPage: 1,
          padding: {
            right: '0px',
            left: '0px'
          }
        }
      }
    });

    const bar = splideEl.querySelector('.my-carousel-progress-bar');

    if (bar) {
      splide.on('mounted move', () => {
        const end = splide.Components.Controller.getEnd() + 1;
        const rate = Math.min((splide.index + 1) / end, 1);
        bar.style.width = `${rate * 100}%`;
      });
    }

    splide.mount();
    splideEl.classList.add('splide--related-initialized');
  });
}

/* Auto Init */
function autoInitRelatedProducts(scope = document) {
  initRelatedProductsSplide(scope);
}

/* Initial Load */
document.addEventListener('DOMContentLoaded', () => {
  autoInitRelatedProducts();

  document.querySelectorAll('product-recommendations').forEach((el) => {
    relatedObserver.observe(el, {
      childList: true,
      subtree: true
    });
  });
});

/* Shopify Theme Editor */
document.addEventListener('shopify:section:load', (e) => {
  autoInitRelatedProducts(e.target);
});

document.addEventListener('shopify:section:select', (e) => {
  autoInitRelatedProducts(e.target);
});

/* Observe AJAX Load */
const relatedObserver = new MutationObserver(() => {
  autoInitRelatedProducts();
});

// PDP Video Gallery
document.addEventListener('DOMContentLoaded', function () {

  const successMessage = document.querySelector('.form-status');

  if (successMessage) {

    window.location.href = '/pages/thank-you';

  }

});

document.querySelectorAll('.product-link').forEach((item) => {
  item.addEventListener('click', function () {
    sessionStorage.setItem('breadcrumb_collection_handle', this.dataset.collection);
    sessionStorage.setItem('breadcrumb_collection_title', this.dataset.collectionTitle);
  });
});